import { FeatureToggle } from '@/resources/enums/featureToggle'
import { SupportChatProviderName } from './types'

export const SUPPORT_CHAT_SPLIT_NAME =
  process.env.ZENDESK_SUPPORT_CHAT_SPLIT ?? 'seller_zendesk_support_chat'

type ProviderConfig = {
  provider?: SupportChatProviderName
}

type ResolverParams = {
  treatment?: string
  config?: string | null
}

const isProvider = (value: string): value is SupportChatProviderName =>
  value === 'sprinklr' || value === 'zendesk'

const parseConfig = (config?: string | null): ProviderConfig | null => {
  if (!config) return null

  try {
    const parsed = JSON.parse(config) as ProviderConfig
    return parsed
  } catch {
    return null
  }
}

export const getSupportChatProvider = ({
  treatment = FeatureToggle.OFF,
  config = null,
}: ResolverParams): SupportChatProviderName => {
  if (treatment !== 'on') {
    return 'sprinklr'
  }

  const parsedConfig = parseConfig(config)
  const configuredProvider = parsedConfig?.provider

  if (!configuredProvider) {
    return 'zendesk'
  }

  return isProvider(configuredProvider) ? configuredProvider : 'sprinklr'
}
